import React from 'react';

// The cart line's `modifiers` is a tree: a modifier has modifierItems, and a chosen
// item may carry its own `modifiers` (nested selections). modifierLabels only holds the
// top level, so we walk the tree here to surface nested choices too.
const CartModifierList = ({ modifiers = [] }) => {
  if (!modifiers.length) return null;

  return (
    <>
      {modifiers.map((modifier) => (
        <React.Fragment key={modifier.modifierId}>
          <p className="cart__item__modifier">{modifier.label}</p>
          {(modifier.modifierItems || []).map((item) => (
            <CartModifierList key={item.itemId} modifiers={item.modifiers} />
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default CartModifierList;
